
import {
    disableGeoSearch,
    isMobileDevice,
    setFilterBtnEvent,
    updateFavCounts
} from "./utils.esm";
import {customGaSetDimension} from "./ga-custom";
import {autocompleteFn} from "./autocomplete-fn";

export default class Toolbar {

    constructor() {
        console.log('init Toolbar Component');

        if(document.querySelector('.Search_location_name')) this.locationInputClearValuesOnEmpty();

        this.filtersSection = document.querySelector('#filtersSection');
        this.setEvents();

        if(document.querySelector('.fav-count')) updateFavCounts();
    }

    setEvents() {
        if (document.querySelector('#filtersSection form')) {
            this.filterFormSubmit(document.querySelector('#filtersSection form'), '#`ui-id-2`');
            this.filterFormSubmit(document.querySelector('#searchModal form'), '#ui-id-1');
        }

        const filterModalElement = document.querySelector('#filterModal');
        if(filterModalElement)
            filterModalElement.querySelector('#filter_results').addEventListener('click', () => window.filterModal.hide());

        const requestLocationBtns = document.querySelectorAll('.requestLocation');
        requestLocationBtns.forEach(requestLocationBtn => requestLocationBtn
                .addEventListener('click', (e) =>
                    e.target.classList.contains('on') ? disableGeoSearch() : autocompleteFn.homeNearByBtn('#main-search-nombre')));

        setFilterBtnEvent();

        if(!isMobileDevice && this.filtersSection) {
            window.addEventListener('scroll', () => {
                const scrollHeight = window.scrollY;
                const distance = Object.values(document.querySelectorAll('.list-area-dropdown-content, #filtersSection'))
                    .reduce((sum, item) => {
                        return sum + item.getBoundingClientRect().height;
                    }, 0);

                this.filterSticky(this.filtersSection, scrollHeight, distance);
            });
        }

        if(filterModalElement) {
            filterModalElement.addEventListener('shown.bs.modal', () => {
                document.body.style.overflow = 'hidden';
            });
            filterModalElement.addEventListener('hidden.bs.modal', () => {
                this.closeFilterModal().then();
                document.body.style.overflow = 'auto';
            });
        }
    }

    async closeFilterModal() {
        await window.filterManager.loadAds();
        customGaSetDimension('dimension2', window.filterManager.getSelectedFilters());
    }

    locationInputClearValuesOnEmpty() {
        Array.from(document.querySelectorAll('.Search_location_name')).forEach((location) => {
            location.addEventListener('keyup', () => {
                if(location.value !== "") return;
                document.querySelectorAll('input[name="Search[city_id]"]').forEach(input => input.value = '');
                document.querySelectorAll('input[name="Search[area_id]"]').forEach(input => input.value = '');
            });
        });
    }

    filterFormSubmit(element) {
        element.addEventListener('submit', (event) => {
            element = event.target;
            if(localStorage.getItem('geosearch_active') === '1') element.querySelector('.Search_location_name').value =
                document.querySelector(".Search_location_name").getAttribute('data-cityname');
            return true;
        });
    }

    filterSticky(targetElement, scrollHeight, targetHeight) {
        const headerElement = document.querySelector('header.position-relatives');
        document.querySelectorAll('.filters-spacer').forEach(item => item.remove());

        if (scrollHeight > targetHeight) {
            if (document.querySelectorAll('.order-lg-2 > .filters-spacer').length === 0) {
                const div = document.createElement('div');
                div.className = "filters-spacer";
                div.style.height = "50px";
                div.style.opacity = "0";

                targetElement.parentElement.append(div);
            }

            targetElement.classList.add('sticky');
            headerElement.classList.add('sticky-behaviour');

        } else {
            headerElement.classList.remove('sticky-behaviour');
            targetElement.classList.remove('sticky');
        }
    }

}